import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginLeftImageInfoNoButtons } from './PluginLeftImageInfoNoButtons';
import { PluginLeftImageInfoNoButtonsContent } from './PluginLeftImageInfoNoButtonsContent';
import { PluginLeftImageInfoNoButtonsFigure } from './PluginLeftImageInfoNoButtonsFigure';

type Props = {
  index: number;
  data: PluginLeftImageInfoNoButtons;
  updateData: (element: IElement, index: number) => void;
};

export const PluginLeftImageInfoNoButtonsFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginLeftImageInfoNoButtons>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-left-image-info">
          <div className="showcase">
            <PluginLeftImageInfoNoButtonsContent data={data} update={update} />
            <PluginLeftImageInfoNoButtonsFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
